import { render, staticRenderFns } from "./MainLedgerPrintVAT.vue?vue&type=template&id=131811b2&scoped=true"
import script from "./MainLedgerPrintVAT.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintVAT.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintVAT.vue?vue&type=style&index=0&id=131811b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131811b2",
  null
  
)

export default component.exports